import Cookies from "js-cookie";

export function setupUserTimezoneCookie() {
    Cookies.set(
        "irc_timezone",
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        { expires: 1, sameSite: "Strict" }
    );
}
